import React from "react";
import dateFormat from "dateformat";
const SingleItem = ({ index, data, paginateData, handleLogout }) => {
  return (
    <>
      <tr>
        <td data-label="S.N.">

          {parseFloat(index + 1) +
            parseFloat(paginateData?.page) * parseFloat(paginateData?.limit) -
            10}
        </td>
        <td data-label="Name">
          <div className="user">
            <span className="name">{data?.adminId?.name}</span>
          </div>
        </td>
        <td data-label="Device Id">
          {data?.deviceId}
        </td>
        <td data-label="Platform">
          {data?.platform}
        </td>
        <td data-label="Browser">
          {data?.browser}
        </td>

        <td data-label="Last Active">
          {dateFormat(data?.lastActive, "d-m-yyyy h:MM:ss TT")}
        </td>

        <td data-label="Action">
          <button
            className="btn btn-sm btn-outline-danger ms-1 user-logout-btn"
            onClick={() => handleLogout(data?._id)}
          >
            <i class="las la-sign-out-alt "></i>Logout
          </button>
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
